import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3664566a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3664566a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Loader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/Loader.vue').default,Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,MapFindPaddock: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/map/find-paddock/MapFindPaddock.vue').default,Iframe: require('/home/runner/work/platform/platform/packages/client/src/components/elements/content-editor/iframe.js').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
